<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>
<app-sidebar [showNavigation]="true">
    <div style="height: 45px"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button
                class="btn btn-primary btn-block"
                type="button"
                (click)="save()"
                [disabled]="this.statementForm.invalid || this.statementFormArray.invalid"
            >
                Save
            </button>
        </li>
        <li class="d-grid gap-2">
            <button
                class="btn btn-success btn-block"
                type="button"
                (click)="send()"
                [disabled]="this.statementForm.invalid || this.statementFormArray.invalid"
            >
                Send
            </button>
        </li>
    </ul>
</app-sidebar>

<div class="main-content">
    <div class="table-container">
        <div>
            <div class="main-content-header">
                <h3>Kajmand / Terminal</h3>
            </div>
            <div class="container-fluid">
                <div class="row justify-content-start" [formGroup]="statementForm">
                    <div class="col-12 col-xl-6 col-xxl-4 col-min-width-400">
                        <app-info-group
                            headline="Kajmand bestilling"
                            size="fit"
                        >
                            <app-info-group-body>
                                <table>
                                    <tr>
                                        <td class="col-label">Dato</td>
                                        <td class="col-value">
                                            <div class="informantorderdate-input">
                                            <app-tba-date-time
                                                [(date)]="statementForm.controls['informantOrderDate'].value"
                                                id="informantOrderDate"
                                                (dateChange)="reInformantorderdate()"
                                            ></app-tba-date-time>
                                        </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Sag</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="informantOrderCase"
                                                id="informantOrderCase"
                                                name="informantOrderCase"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Job</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="informantOrderJob"
                                                id="informantOrderJob"
                                                name="informantOrderJob"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Maskine</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="informantOrderMachine"
                                                id="informantOrderMachine"
                                                name="informantOrderMachine"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Job nr.</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="informantOrderMachineJobNumber"
                                                id="informantOrderMachineJobNumber"
                                                name="informantOrderMachineJobNumber"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Klar v. skib</td>
                                        <td class="col-value">
                                            <div class="informantOrderreadydate-input">
                                            <app-tba-date-time
                                                [(date)]="statementForm.controls['informantOrderReadyDate'].value"
                                                id="informantOrderReadyDate"
                                                (dateChange)="reInformantorderReadydate()"
                                            ></app-tba-date-time>
                                        </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Notat</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="informantOrderNote"
                                                id="informantOrderNote"
                                                name="informantOrderNote"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                    <div class="col-12 col-xl-6 col-xxl-4 col-min-width-400">
                        <app-info-group
                            headline="Terminal"
                            size="fit"
                        >
                            <app-info-group-body>
                                <table>
                                    <tr>
                                        <td class="col-label">
                                            Forbrug v. flere maskiner
                                        </td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="terminalStatementMultipleMachines"
                                                id="terminalStatementMultipleMachines"
                                                name="terminalStatementMultipleMachines"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Job nr.</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="terminalStatementJobNumber"
                                                id="terminalStatementJobNumber"
                                                name="terminalStatementJobNumber"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Notat</td>
                                        <td class="col-value">
                                            <textarea
                                                class="form-control"
                                                formControlName="terminalStatementNote"
                                                id="terminalStatementNote"
                                                name="terminalStatementNote"
                                                appTextareaAutosize
                                            ></textarea>
                                        </td>
                                    </tr>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-1" style="min-width: 660px">
                        <app-info-group
                            headline="Terminal opgørelse"
                            size="fit"
                        >
                            <app-info-group-body>
                                <div
                                    *ngIf="
                                        statementFormArray.controls.length === 0
                                    "
                                style="padding: 7px">
                                    Ingen opgørelser oprettet.
                                    <a
                                        href="javascript:;"
                                        (click)="addStatement()"
                                        >Opret opgørelse</a
                                    >
                                </div>
                                <table
                                    class="terminal-table"
                                    *ngIf="
                                        statementFormArray.controls.length > 0
                                    "
                                    [formGroup]="statementFormList"
                                >
                                    <thead>
                                        <tr>
                                            <th class="date">Dato</th>
                                            <th>Sats</th>
                                            <th class="value">Timer/Antal</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container
                                            *ngFor="
                                                let statement of statementFormArray.controls;
                                                let i = index
                                            "
                                        >
                                            <tr [formGroup]="statement">
                                                <td>
                                                    <app-date-picker
                                                        id="terminalStatementDate"
                                                        [(date)]="statement.get('date').value"
                                                        (dateChange)="revalidate(i)"
                                                    ></app-date-picker>
                                                </td>
                                                <td>
                                                    <select
                                                        class="form-select"
                                                        formControlName="terminalStatementId"
                                                    >
                                                        <option *ngFor="let terminalStatement of terminalStatements" [value]="terminalStatement.id">
                                                            {{ terminalStatement.name }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input
                                                        class="form-control"
                                                        type="text"
                                                        placeholder="Angiv timer/antal"
                                                        formControlName="value"
                                                    />
                                                </td>
                                                <td class="btn-control-group">
                                                    <div>
                                                        <button
                                                            class="btn btn-danger"
                                                            type="button"
                                                            (click)="removeStatement(i)">
                                                            <i
                                                                class="fa fa-trash"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                        <button
                                                            *ngIf="i === statementFormArray.controls.length - 1"
                                                            class="btn btn-outline-secondary"
                                                            type="button"
                                                            (click)="addStatement()">
                                                            <i
                                                                class="fa fa-plus"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>

                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
